import React from "react";
import Iframe from "react-iframe";

import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import TextField from "@material-ui/core/TextField";
import Box from "@material-ui/core/Box";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

const IframeTest = (props) => {
  const [value, setValue] = React.useState(1);
  const [searchbox, setSearchBox] = React.useState("");
  const [wordreference, setWordreference] = React.useState(
    "https://www.wordreference.com/fren/"
  );
  const [linguee, setLinguee] = React.useState(
    "https://www.linguee.com/english-french/search?source=auto&query="
  );
  const [mix1, setMix1] = React.useState("");
  const [mix2, setMix2] = React.useState("");
  const [radio, setRadio] = React.useState("fr");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleTextChange = (event) => {
    setSearchBox(event.target.value);
  };

  const handleRadioChange = (event) => {
    setRadio(event.target.value);
    if (searchbox != "") {
      if (event.target.value == "fr") {
        setWordreference("https://www.wordreference.com/fren/" + searchbox);
        setLinguee(
          "https://www.linguee.com/english-french/search?source=auto&query=" +
            searchbox
        );
      } else if (event.target.value == "de") {
        setWordreference("https://www.wordreference.com/deen/" + searchbox);
        setLinguee(
          "https://www.linguee.com/english-german/search?source=auto&query=" +
            searchbox
        );
        setMix1("https://www.dict.cc/?s=" + searchbox);
        setMix2("https://www.crodict.com/german-croatian/" + searchbox);
      } else if (event.target.value == "es") {
        setWordreference("https://www.wordreference.com/esen/" + searchbox);
        setLinguee(
          "https://www.linguee.com/english-spanish/search?source=auto&query=" +
            searchbox
        );
      } else if (event.target.value == "en->fr") {
        setWordreference("https://www.wordreference.com/enfr/" + searchbox);
        setLinguee(
          "https://www.linguee.com/english-french/search?source=auto&query=" +
            searchbox
        );
      } else if (event.target.value == "en->de") {
        setWordreference("https://www.wordreference.com/ende/" + searchbox);
        setLinguee(
          "https://www.linguee.com/english-german/search?source=auto&query=" +
            searchbox
        );
      } else if (event.target.value == "en->es") {
        setWordreference("https://www.wordreference.com/enes/" + searchbox);
        setLinguee(
          "https://www.linguee.com/english-spanish/search?source=auto&query=" +
            searchbox
        );
      }
    }
  };
  return (
    <Accordion id="accorion-iframe">
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <TextField
          id="standard-basic"
          label="Search"
          value={searchbox}
          onChange={handleTextChange}
        />
      </AccordionSummary>
      <AccordionDetails>
        <div>
          {/* <iframe id="iframe" src="https://www.wordreference.com/fren/allure" style="height:380px;width:100%"></iframe> */}

          <FormControl component="fieldset">
            {/* <FormLabel component="legend">Gender</FormLabel> */}
            <RadioGroup
              row
              aria-label="filter"
              name="gender1"
              value={radio}
              onChange={handleRadioChange}
            >
              <FormControlLabel value="es" control={<Radio />} label="es" />
              <FormControlLabel value="de" control={<Radio />} label="de" />
              <FormControlLabel value="fr" control={<Radio />} label="fr" />
              <FormControlLabel
                value="en->es"
                control={<Radio />}
                label="en->es"
              />
              <FormControlLabel
                value="en->de"
                control={<Radio />}
                label="en->de"
              />
              <FormControlLabel
                value="en->fr"
                control={<Radio />}
                label="en->fr"
              />
            </RadioGroup>
          </FormControl>

          <Tabs
            value={value}
            indicatorColor="primary"
            textColor="primary"
            onChange={handleChange}
            aria-label="disabled tabs example"
          >
            <Tab label="wordreference"></Tab>
            <Tab label="linguee" />
            <Tab label="mix1" />
            <Tab label="mix2" />
          </Tabs>
          <TabPanel value={value} index={0}>
            <Iframe
              url={wordreference}
              width="450px"
              height="450px"
              id="myId"
              className="myClassname"
              display="initial"
              position="relative"
            />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Iframe
              url={linguee}
              width="450px"
              height="450px"
              id="myId"
              className="myClassname"
              display="initial"
              position="relative"
            />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <Iframe
              url={mix1}
              width="450px"
              height="450px"
              id="myId"
              className="myClassname"
              display="initial"
              position="relative"
            />
          </TabPanel>
          <TabPanel value={value} index={3}>
            <Iframe
              url={mix2}
              width="450px"
              height="450px"
              id="myId"
              className="myClassname"
              display="initial"
              position="relative"
            />
          </TabPanel>
        </div>
      </AccordionDetails>
    </Accordion>
  );
};
export default IframeTest;
